import OrderDataServiceClass from '../Services/OrderData.service';

export const OrderDataService = OrderDataServiceClass;
export const xyz = 1;
